import { Link, Stack, Typography } from '@mui/material';
import React from 'react';

import { OperatingSystem } from './cliInstructionTypes';
import { CliCommandBlock } from './CopyableCliBlock';

const MAC_AWS_CLI_DOWNLOAD_URL = 'https://awscli.amazonaws.com/AWSCLIV2.pkg';
const WINDOWS_AWS_CLI_DOWNLOAD_URL = 'https://awscli.amazonaws.com/AWSCLIV2.msi';

const OsInstallInstructions = ({ selectedOs }: { selectedOs: OperatingSystem }) => {
  if (selectedOs === 'windows') {
    return (
      <Stack spacing={1}>
        <Typography variant="body2">
          Download and run the Windows installer:{' '}
          <Link href={WINDOWS_AWS_CLI_DOWNLOAD_URL} target="_blank" rel="noreferrer">
            AWSCLIV2.msi
          </Link>
        </Typography>
      </Stack>
    );
  }

  if (selectedOs === 'linux') {
    return (
      <Stack spacing={1}>
        <Typography variant="body2" color="text.secondary">
          Copy these commands into a terminal. You may need an administrator password for the install step.
        </Typography>
        <CliCommandBlock
          command={
            'curl "https://awscli.amazonaws.com/awscli-exe-linux-x86_64.zip" -o "awscliv2.zip"\nunzip awscliv2.zip\nsudo ./aws/install'
          }
        />
      </Stack>
    );
  }

  return (
    <Stack spacing={1}>
      <Typography variant="body2">
        Download and run the macOS installer:{' '}
        <Link href={MAC_AWS_CLI_DOWNLOAD_URL} target="_blank" rel="noreferrer">
          AWSCLIV2.pkg
        </Link>
      </Typography>
      <Typography variant="body2" color="text.secondary">
        After installation, open Terminal from Spotlight or Applications.
      </Typography>
    </Stack>
  );
};

export default OsInstallInstructions;
